<template>
  <el-dialog width="720px" title="生成激活码"  :before-close="handleClickCancel" :close-on-press-escape="false"
             :close-on-click-modal="false" :visible.sync="generateAuthCodeVisible">
    <div class="details">

      <el-form  ref="currencyForm"  size="small" v-loading="loading"   label-position="top"   label-width="100px"  :model="currencyForm"  :rules="currencyFormRules">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="license_id" label="产品名称">
              <el-input   v-model="productName" disabled  placeholder="请输入产品名称"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="date" label="本次授权截止时间">
              <el-date-picker
                :append-to-body="false"
                v-model="currencyForm.date"
                type="datetimerange"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                start-placeholder="开始日期"
                end-placeholder="结束日期" :picker-options="pickerOptions">
              </el-date-picker>
              <p style="color: rgba(140,139,139,1)" v-if="productDetail.order">可选范围：{{productDetail.order.start_date +' ~ ' + productDetail.order.end_date}}</p>
            </el-form-item>
          </el-col>
          <el-col :span="24">
             <el-form-item prop="value_code" label="">
              <div class="flex_js_wrap" style="justify-content: left">
                 <el-checkbox v-model="offline_time">定期联网验证</el-checkbox>
                 <div style="margin-left: 30px"  v-if="offline_time">连续离线每 <el-input-number style="width: 100px" v-model="currencyForm.value_code" :max="99" :min="1" :controls="false"></el-input-number> 天需要联网验证一次</div>
                 <div style="margin-left: 30px"  v-else>提示:未启用联网验证，激活码将无法回收，无法找回</div>
              </div>
               <p  style="color: rgba(140,139,139,1)" v-if="offline_time">只能填入正整数，最小为1，最大为99。</p>
             </el-form-item>
          </el-col>


<!--          <el-col :span="24">-->
<!--            <el-form-item prop="list" label="必选模块">-->
<!--              <el-checkbox-group v-model="currencyForm.module_require">-->
<!--                <el-checkbox label="基础模块1" value="1"></el-checkbox>-->
<!--                <el-checkbox label="基础模块2" value="2"></el-checkbox>-->
<!--              </el-checkbox-group>-->
<!--            </el-form-item>-->
<!--          </el-col>-->

<!--          <el-col :span="24">-->
<!--            <el-form-item prop="list" label="可选模块">-->
<!--              <el-checkbox-group v-model="currencyForm.module_optional">-->
<!--                <el-checkbox label="基础模块1" value="1"></el-checkbox>-->
<!--                <el-checkbox label="基础模块2" value="2"></el-checkbox>-->
<!--              </el-checkbox-group>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button  size="small" :disabled="BtnDisabled" @click="handleClickCancel">取消</el-button>
      <el-button  size="small" type="primary" :disabled="BtnDisabled" @click="handleClickConfirm">生成激活码</el-button>
    </div>
  </el-dialog>
</template>
<script>

import { genLicenseCode,productDetail} from '@/api/api'
import {mapState} from "vuex";
import {convertToCurrentTimezone,convertToUTC} from '@/utils'
export default {
  name: 'generate_auth_code',
  props: {
    generateAuthCodeVisible: {
      type: Boolean,
      default: false,
    },
    licenseId: {
      type: Number,
      default: 0,
    },
    productName: {
      type: String,
      default: '',
    },
    generateAuthData:{
      type: Object,
      default: ()=>{},
    },
  },
  data() {

    return {
      loading:false,
      BtnDisabled: false,
      offline_time:false, //定期联网验证
      currencyForm:{
       license_id: "",
       date:"",
       start_date: "",
       end_date: "",
       license_module_id:'',
       value_code:'',
       module_require:[],
       module_optional:[]
      },
      currencyFormRules:{
        license_id:[{ required: true, message: '请选择', trigger: 'change'}],
        date:[{ required: true, message: '请选择本次授权截止时间', trigger: 'change'}],
        value_code:[{ required: true,trigger: 'change',validator: (rule, value, callback) => {
            if(this.offline_time && !value) return callback(new Error("请输入1-99的正整数"));
            callback()
        }}],
      },
      productDetail:{},
      pickerOptions: {
        disabledDate: (time) => {
          if (this.productDetail.order && this.productDetail.order.start_date && this.productDetail.order.end_date) {
            return (
              time.getTime() < new Date(this.productDetail.order.start_date).getTime() ||
              time.getTime() > new Date(this.productDetail.order.end_date).getTime()
            );
          }
          return false; // 如果没有设置开始或结束日期，允许选择任何日期
        },
      },
    }
  },

  created() {
    if(this.generateAuthData && this.generateAuthData.license_module_id){
      this.currencyForm.license_module_id = this.generateAuthData.license_module_id
      this.currencyForm.value_code = this.generateAuthData.value_code
      if(this.generateAuthData.value_code == 0){
        this.offline_time = false
        this.currencyForm.value_code = 7
      }else{
        this.offline_time = true
      }
    }
    if(this.licenseId){
      this.currencyForm.license_id = this.licenseId
      this.getAdminProductDetail()
    }
  },
  computed: {
    ...mapState(['adminUserInfo']),

  },
  mounted() {

  },
  methods: {
    convertToCurrentTimezone(utcTime,separator,type) {
      return convertToCurrentTimezone(utcTime,separator,type);
    },
    // 获取
    getAdminProductDetail(){
      this.loading = true
      let postData = {
        id:this.licenseId,
      }
      productDetail(postData).then(res => {
        if (res.code === 200) {
          let {data} = res
          if(data.order.start_date){
            this.currencyForm.date = [convertToCurrentTimezone(data.order.start_date,'-','datetime'),  convertToCurrentTimezone(data.order.end_date,'-','datetime')]

            data.order.start_date = convertToCurrentTimezone(data.order.start_date,'/','datetime')
            data.order.end_date = convertToCurrentTimezone(data.order.end_date,'/','datetime')
          }
          this.productDetail = data
          console.log(data.order.start_date);


        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },

    handleClickConfirm(){
      this.$refs.currencyForm.validate(valid => {
        if (valid) {
          let postData = {
            license_id: this.currencyForm.license_id,
            start_date: convertToUTC(this.currencyForm.date[0],'datetime'),
            end_date: convertToUTC(this.currencyForm.date[1],'datetime'),
            license_module_id:this.currencyForm.license_module_id,
            value_code:this.offline_time ? this.currencyForm.value_code : 0,
            module_value:this.offline_time ?  `${this.currencyForm.value_code}天` :  '无需在线校验',
            module_require:this.currencyForm.module_require.join(','),
            module_optional:this.currencyForm.module_optional.join(','),
          }
          this.BtnDisabled = true
          genLicenseCode(postData).then(res => {
            if (res.code === 200) {
              this.BtnDisabled = false
              this.$emit('success',{product_name:this.productName,license_code:res.data.license_code})
              this.$emit('update:generateAuthCodeVisible', false)
            }else{
              this.BtnDisabled = false
            }
          }).catch((e) => {
            this.BtnDisabled = false
          })
        }
      })
    },


    //取消事件
    handleClickCancel() {
      //关闭对话框
      this.$emit('update:generateAuthCodeVisible', false)
    },


  },

}
</script>
<style lang="scss" scoped>
p {
  margin: 0;
  padding: 0;
}
.mt-15{
  margin-top: 15px;
}
.el-select{
  display: block;
}
.tips{
  line-height: 24px;
  margin-bottom: 18px;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  text-align: center;
}
::v-deep .el-input-number{
  width: 100%;
  .el-input__inner{
    text-align: left;
  }
}
::v-deep .el-date-editor--datetimerange{
  width: 100%;

}
::v-deep .el-picker-panel{
  transform: translateY(15px);
}
</style>
